import { Button, Grid } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import { Link } from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import staticFiles from "../services/staticApi";

// import FilterTable from '../components/filtertable';
import http from "../services/httpService";
import {
  addLookupManagerPath,
  getDate,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
import SearchBar from "material-ui-search-bar";

const columns = [
  {
    id: "lookupid",
    label: "Lookup",
    minWidth: 170,
    filter: true,
    format: "number",
  },
  {
    id: "lookupmasterid",
    label: "Lookup Master ID",
    minWidth: 150,
    filter: true,
    format: "number",
  },
  { id: "lookupname", label: "Lookup Name", minWidth: 150, filter: true },
  {
    id: "lookuppagename",
    label: "Lookup Page Name",
    minWidth: 150,
    filter: true,
  },
  { id: "lookupparam1", label: "Lookup Parameter 1", minWidth: 150 },
  { id: "lookupparam2", label: "Lookup Parameter 2", minWidth: 150 },
  { id: "lookupfile", label: "Lookup File", type: 'attach', minWidth: 150 },
  { id: "lookupstatus", label: "Status", minWidth: 150 },
  { id: "detailsButton", label: "Edit", minWidth: 150 },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});
function LookupMaster() {
  const classes = useStyles();
  let history = useHistory();
  const [filterColumns, setFilterColumns] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  const [fullRows, setFullRows] = React.useState([]);

  const [filetedColumn, setFilteredColumn] = React.useState("");
  const [filterLable, setfilterLable] = React.useState("Enter");
  const [filterText, setFilterText] = React.useState("");
  const [showAddBtn, setShowAddBtn] = React.useState(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };

  const handleFilter = (e) => {
    setFilteredColumn(e.target.value);
    setFilterText("");
    setfilterLable("enter " + e.target.value);
  };
  const filterTable = (e) => {
    let data = fullRows.filter((object) => {
      return typeof (object[filetedColumn] === "number")
        ? object[filetedColumn] == e.target.value
        : object[filetedColumn] &&
        object[filetedColumn]
          .toLowerCase()
          .includes(e.target.value.toLowerCase());
    });
    setFilterText(e.target.value);
    setRows(data);
    setPage(0);
  };
  const changePath = () => {
    history.push(addLookupManagerPath);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const viewLookupDetails = (object) => {
    history.push({
      pathname: addLookupManagerPath,
      state: object,
    });
  };
  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter")
    localStorage.removeItem("selectedfiltersdata")
    localStorage.removeItem('selectedinvestorfiltersdata')
    http.get("/login_permissions").then((res) => {
      if (
        res &&
        res.data &&
        res.data.Data &&
        Array.isArray(res.data.Data) &&
        res.data.Data.length > 0
      ) {
        let current_permission = res.data.Data.filter((obj) => {
          return obj.Mainmenu === "Lookup Manager";
        });
        if (current_permission && current_permission.length > 0) {
          if (
            current_permission[0]["Submenus"].indexOf(
              "Add New Lookup Detail"
            ) !== -1
          ) {
            setShowAddBtn(true);
          } else {
            setShowAddBtn(false);
          }
          if (
            current_permission[0]["Submenus"].indexOf("Lookup Details List") !==
            -1
          ) {
            toast.loading("Please wait...");

            http
              .get("/lookupmaster")
              .then((response) => {
                let filter = columns.filter((obj) => {
                  return obj.filter === true;
                });
                setFilterColumns(filter);
                if (response && response.data && response.data.length > 0) {

                  let finalData = [];
                  let tempDta = response.data;
                  let tempStatusDta = tempDta.map((item, index) => {
                    const swapValue = (item) => {
                      Object.keys(item).forEach((key) => {
                        //(Object.keys(item));
                        // if (!item[key]) {
                        //     item[key] = "N/A";
                        // }
                      });
                    };
                    swapValue(item);


                    if (item.lookupparam1 === null) {
                      finalData.push(item.lookupparam1 = "N/A")

                    }
                    else {
                      finalData.push(item.lookupparam1)

                    }

                    if (item.lookupparam2 === null) {
                      finalData.push(item.lookupparam2 = "N/A")

                    }
                    else {
                      finalData.push(item.lookupparam2)

                    }
                    if (item.lookupstatus === null) {
                      finalData.push(item.lookupstatus = "N/A")

                    }
                    else {
                      finalData.push(item.lookupstatus)

                    }
                    if (item.lookuppagename === null) {
                      finalData.push(item.lookuppagename = "N/A")

                    }
                    else {
                      finalData.push(item.lookuppagename)

                    }
                    if (item.lookupfile === null) {
                      finalData.push(item.lookupfile = "N/A")

                    }
                    else {
                      finalData.push(item.lookupfile)

                    }
                    return item;
                  });
                  setOriginalRows(tempDta.slice().reverse());
                  setRows(tempDta.slice().reverse());
                  setFullRows(response.data);
                  toast.dismiss();
                }
              })
              .catch((error) => { console.log('error') });

          } else if (
            current_permission[0]["Submenus"].indexOf(
              "Add New Lookup Detail"
            ) !== -1
          ) {
            changePath();
          }
        }
      }
    });
  }, []);

  return (
    <div className={(classes.root, "pb30")}>
      <AppBar
        position="static"
        style={{ marginBottom: 5, paddingTop: 3, paddingBottom: 3 }}
      >
        <Grid container component="main" className="overviewbar">
          <Grid item xs={12} sm={2} md={2} lg={2} xl={1}>
            <Button
              variant="contained"
              color="primary"
              style={{ marginLeft: 10, borderRadius: 60 }}
            >
              Overview
            </Button>
          </Grid>
          {showAddBtn ? (
            <Grid item xs={12} sm={8} md={4}>
              <Button
                variant="outlined"
                color="primary"
                style={{ marginLeft: 10, borderRadius: 60 }}
                startIcon={<AddCircleOutlineIcon />}
                onClick={changePath}
              >
                Add New Lookup Detail
              </Button>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
      </AppBar>
      <Paper className={classes.root}>
        <SearchBar
          value={searched}
          onChange={(searchVal) => requestSearch(searchVal)}
          onCancelSearch={() => cancelSearch()}
          className={"mt30"}
        />
        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <TableContainer className={classes.container}>
          {/* <Select displayEmpty labelId="filetedColumn" id="filetedColumn" value={filetedColumn} variant="outlined" className={classes.select} onChange={handleFilter} name="Country">
                        <MenuItem value="">Select Filter</MenuItem>
                        {filterColumns.map(obj => {
                            return (
                                <MenuItem value={obj.id} key={obj.id}>{obj.label}</MenuItem>
                            )
                        })}
                    </Select>
                    <TextField label={filterLable}  style={filetedColumn!==""?{display:"block"}:{display:"none"}} onChange={filterTable} value={filterText}/> */}
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className='prospect_table'

                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {
                rows.length !== 0 ? (
                  <>
                    {rows
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index + "a"}
                            className='prospecttable'

                          >
                            {columns.map((column, index) => {
                              const value = row[column.id];
                              return (
                                <TableCell
                                  key={index + column.id}
                                  align={column.align}
                                >
                                  {column.format && typeof value === "number" ? (
                                    Number(value)
                                  ) : column.id === "detailsButton" && !showAddBtn ? (
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      style={{ borderRadius: 20 }}
                                      disabled
                                    >
                                      <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={
                                          orderBy === column.id ? order : "asc"
                                        }
                                        onClick={(e) =>
                                          handleRequestSort(
                                            e,
                                            column.id,
                                            column.format
                                          )
                                        }
                                      >
                                        {column.label}
                                      </TableSortLabel>
                                    </Button>
                                  ) : column.id === "detailsButton" && showAddBtn ? (
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      style={{ borderRadius: 20 }}
                                      onClick={() => viewLookupDetails(row)}
                                    >
                                      {column.label}
                                    </Button>
                                  ) : column.format === "Date" ? (
                                    getDate(value)
                                  ) : column.type && column.type === 'attach' && value !== 'N/A' ? (
                                    <Link
                                      href={value}
                                      target="_blank"
                                      variant="body2"
                                      gutterBottom
                                      style={{ cursor: "pointer" }}
                                    >
                                      {value}
                                    </Link>
                                  ) : (
                                    value
                                  )

                                  }
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </>
                ) : (
                  <TableCell colspan="7" style={{ "text-align": "center", margin: "10px 0px" }} >
                    Records Not Available</TableCell>


                )
              }

            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}
export default LookupMaster;
